const routerTitle = {
  LOGIN: 'pages.auth.login.title',
  REGISTER: 'pages.auth.register.title',
  CONFIRM_MAIL: 'pages.auth.confirm_mail.title',
  FORGOT_PASSWORD: 'pages.auth.forgot.title',
  CONFIRM_MAIL_FORGOT: 'pages.auth.confirm_mail_forgot.title',
  NEW_PASSWORD: 'pages.auth.new_password.title',
  PROJECT: 'pages.manager.sidebar.project',
  DETAIL_PROJECT: 'pages.manager.sidebar.detail_project',
  CREATE_PROJECT: 'pages.steps.create_project',
  PLAN: 'pages.manager.sidebar.plan',
  REQUEST: 'pages.manager.sidebar.request',
  MY_ACCOUNT: 'pages.manager.sidebar.my_account',
  MY_ACCOUNT_EDIT_INFO: 'pages.manager.sidebar.my_account_edit_info',
  MY_ACCOUNT_EDIT_PASSWORD: 'pages.manager.sidebar.my_account_edit_password',
  MY_ACCOUNT_CHANGE_EMAIL: 'pages.manager.sidebar.my_account_edit_email',
  MY_ACCOUNT_CHANGE_EMAIL_CONFIRM: 'pages.auth.confirm_mail.title',
  MY_ACCOUNT_LEAVE: 'pages.settings.leave.title',
  MESSAGE: 'pages.manager.sidebar.survey',
  STEP_INFORMATION: 'pages.steps.information.title',
  STEP_UPLOAD: 'pages.steps.upload.title',
  STEP_PERSPECTIVE_DELIVERY: 'pages.steps.perspective_delivery.title',
  STEP_VIEWER: 'pages.steps.viewer.title',
  STEP_CONFIRMATION: 'pages.steps.confirmation.title',
  STEP_COMPLETED: 'pages.steps.completed.title',
  CRAFTING_PROJECT: 'pages.manager.project.crafting.title',
  CRAFTING_PROJECT_CONFIRM: 'pages.manager.project.crafting_confirm.title',
  FEEDBACK_BACK_PROJECT_INTRO: 'pages.manager.project.feedback_intro.meta',
  FEEDBACK_BACK_PROJECT: 'pages.manager.project.feedback.meta',
  FEEDBACK_BACK_PROJECT_CONFIRM: 'pages.manager.project.feedback_confirm.meta'
} as const

export default routerTitle
